// src/pages/categories/CategoryList.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CategoryForm from './CategoryForm';
import API_BASE_URL from '../../utils/config';

export default function CategoryList() {
  const [categories, setCategories] = useState([]);
  const [editingCategory, setEditingCategory] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const token = localStorage.getItem('token');

  const fetchCategories = async () => {
    const res = await axios.get(`${API_BASE_URL}/api/categories`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setCategories(res.data);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleEdit = (category) => {
    setEditingCategory(category);
    setShowForm(true);
  };

  const handleAdd = () => {
    setEditingCategory(null);
    setShowForm(true);
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Categories</h2>
        <button
          className="bg-blue-600 text-white px-4 py-1 rounded"
          onClick={handleAdd}
        >
          + Add
        </button>
      </div>

      {showForm && (
        <CategoryForm
          category={editingCategory}
          onSuccess={() => {
            setShowForm(false);
            fetchCategories();
          }}
          onCancel={() => setShowForm(false)}
        />
      )}

      <table className="w-full border mt-4">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 text-left">ID</th>
            <th className="p-2 text-left">Name</th>
            <th className="p-2 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((cat) => (
            <tr key={cat.id} className="border-t">
              <td className="p-2">{cat.id}</td>
              <td className="p-2">{cat.name}</td>
              <td className="p-2">
                <button
                  onClick={() => handleEdit(cat)}
                  className="text-blue-600 hover:underline"
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
